<div class="container" [ngStyle]="{ height: graph ? '185vh' : '130vh' }">
  <div class="toggle">
    <mat-slide-toggle (change)="toggleAEConsumption()">
      Include AE Consumption Only
    </mat-slide-toggle>
  </div>
  <div class="toggle one">
    <mat-slide-toggle (change)="toggleGoodWeather()">
      Good Weather Only
    </mat-slide-toggle>
  </div>
  <div class="content">
    <div #bothChartContainer [chart]="graphChart" class="graphId"></div>
  </div>
</div>
